<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card v-if="dialog">
        <v-card-title>
          <span class="text-h5">Prozess zur Freigabe versenden</span>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <small v-if="error" style="color: red">{{ errorMsg }}</small>
            <v-form v-model="valid" ref="form">
              <v-row>
              <v-col cols="12">
                <v-select
                    v-model="commitDetails.reviewer"
                    :disabled="reviewer != '' && reviewer != null && reviewer != userId"
                    :items="users"
                    :rules="[(v) => !!v || 'Prozessverantwortlicher muss angegeben werden']"
                    label="Prozessverantwortlicher*"
                    item-text="fullName"
                    item-value="userId"
                    required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        name="Kommentar"
                        label="Kommentar*"
                        :rules="[(v) => !!v || 'Prozessverantwortlicher muss angegeben werden']"
                        v-model="commitDetails.commitMsg"
                    ></v-textarea>
                </v-col>
            </v-row>
            </v-form>
          </v-container>
          <small>*zeigt benötigte Felder an</small>
        </v-card-text>
        <v-card-actions>
          <v-btn id="leftButton" text @click="close()">Abbrechen</v-btn>
          <v-btn
            id="rightButton"
            color="primary"
            @click="submitCommit()"
          >
            Freigabeanfrage versenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import userService from "@/components/userService";
import processPublishService from "@/components/processPublishService";
  export default {
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      rules: {
        required: [value => !!value || "Muss ausgefüllt werden"]
      },
      commitDetails: {
        reviewer: null,
        commitMsg: null
      },
      process: null,
      error: false,
      valid: true,
      users: null,
      reviewer: null,
      errorMsg: "Fehler beim Erstellen der Freigabeanfrage"
    }),
    computed:{
        userId() {
            return this.$store.getters.user.username;
        }
    },
    methods:{
      resetData(){
        this.commitDetails = {
            reviewer: null,
            commitMsg: null
        }
        this.error = false;
        this.errorMsg = "Fehler beim Erstellen der Freigabeanfrage";
      },
      async open(item) {
        this.process = item;
        let usersTmp = await userService.retrieveUsers();
        let tmp = await processPublishService.getProcessReviewerFromReleaseHistory(this.process.uuid);
        this.reviewer = tmp.data;
        if(usersTmp) this.users = usersTmp.data;
        this.dialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      submitCommit() {
        if(this.commitDetails.reviewer == null || this.commitDetails.commitMsg == null) {
          this.error = true;
          this.errorMsg = "Bitte alle Felder ausfüllen";
          return;
        }else{
          this.error = false;
          this.commitDetails.uuid = this.process.uuid;
          this.commitDetails.diagramXML = this.process.diagramXML;
          processPublishService.addProcessReleaseRequest(this.commitDetails).then(res => {
              this.resolve();
              this.resetData();
              this.dialog = false;
          })
        }

      },
      close(){
        this.reject();
        this.resetData();
        this.dialog = false;
      }
    }
  }
</script>